import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart } from 'chart.js';
import { callback } from 'chart.js/dist/helpers/helpers.core';
import { round } from 'lodash';
import pptxgen from "pptxgenjs";
import { Message } from 'primeng/api';
import { breadcrumb, link, stat } from 'src/app/admin/layout/header/header.component';
import { MenuItem } from 'src/app/misc/interface/menu-item';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ExportService } from 'src/app/services/export.service';

@Component({
  selector: 'app-assessment-result-module',
  templateUrl: './assessment-result-module.component.html',
  styleUrl: './assessment-result-module.component.scss'
})
export class AssessmentResultModuleComponent {

  @Input() assessmentIds: string[] = []
  @Input() totalMarks: number = 0
  @Input() from: string = 'assessment';

  hideContent = true;

  messages: Message[] = [];

  colors = ["#802d7e", "#1b75bb", "#5b5095", "#2e3171", "#3d2b63"];

  queryParams: any = {};
  stats: stat[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  alldata: any;
  topStats: any;
  subTopStats: any;
  totalGrades: any;

  // Pagination state for multi-takers table
  multiTakersPage: number = 0;
  multiTakersRows: number = 5;
  multiTakersPageData: any[] = [];
  multiTakersFilteredData: any[] = [];
  multiTakersSearchTerm: string = '';

  options: any;
  options2: any;
  totalGradesData: any;

  graphData: any;

  worstPerformingQuestionPercentage = 0.69
  worstPerformingQuestionPercentageInput = 69

  filterOptions: any[] = [
    { name: this.translate('highest'), value: "highest" },
    { name: this.translate('lowest'), value: "lowest" },
    { name: this.translate('latest'), value: "latest" },
    { name: this.translate('earliest'), value: "earliest" },
  ];

  chartColors = ["802d7e", "1b75bb", "5b5095", "2e3171", "3d2b63"];

  selectedFilterOptions: any = "highest"

  @Output() getGradesData: EventEmitter<any> = new EventEmitter<any>();

  mistakersPercentage = 0;

  hiddenItems: any = ["Overall average for the assessment in percentage", "Overall average for the assessment in marks", "Overall average for the assessment in grades", 'domainAnswers', 'listOfMultiTakers', 'listOfMuliTakers'];

  hideCards: any = ["⁠Number of types of Assessments", "Number of Assessments", "Minimum number of questions in an assessment"];
  hasSubCards: any = ["Total number of who attempted", "Total Attendees"]
  isSubCards: any = ["Internal Attendees", "External Attendees", "External Attendees  who attempted", "Internal Attendees who attempted"]

  /** For assessments, these keys are shown first among top stats when non-zero */
  private readonly examSummaryStatOrder: readonly string[] = [
    'Total Attendees',
    'Total number of who attempted',
    'KGate registered users who attempted',
  ];

  downloadCWExcel: boolean = false;
  downloadPowerPoint: boolean = false;

  // Custom tooltip function
  customTooltip = (context: any) => {
    // Context contains information about the hovered data point
    const { dataIndex } = context;
    const value = this.totalGradesData.datasets[0].data[dataIndex];
    return `Value: ${value}`; // Customize this as per your requirement
  };
  criterias: any;
  totalQuestionsData: any;
  totalQuestionsDataGraph: any;
  worstPerformingQuestions: any;
  totalUserResults: any;

  downloadPdf: boolean = false
  downloadExcel: boolean = false


  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private exportService: ExportService,

  ) { }

  params: any

  async ngOnInit() {

    if (this.assessmentIds) {

      const params = { ids: this.assessmentIds }
      this.params = params
      await this.getResults();
      this.fetchGraphData();


    } else {
      this.router.navigate([`/${this.from}`]);
    }
  }
  async generateData(totalGrades: any): Promise<any> {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    this.options = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            font: {
              size: 14,
              family: 'SSTArabic'
            },
            color: '#787878'
          },
          position: "left"
        },
        tooltip: {
          enabled: false,
          external: this.external1
        }
      }
    };

    if (!Array.isArray(totalGrades)) {
      return {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: this.colors
          }
        ]
      };
    }

    return {
      labels: await totalGrades.map((item: any) => { if (item._id == null || item._id == "null") { return "N/A" } else { return item._id } }),
      datasets: [
        {
          data: await totalGrades.map((item: any) => item.sum),
          backgroundColor: this.colors
        }
      ]
    };
  }

  async fetchGraphData() {
    try {

      const queryString = Object.keys(this.params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.params[key])}`)
        .join('&');

      let queryString_var = queryString.replace(/%3F/g, '&').replace(/%3D/g, '=').replace(/%253F/g, '&').replace(/%253D/g, '=');

      console.log("queryString_var", queryString_var)
      console.log("this.params", this.params)


      let url = `${this.from}-result/getBulkGraph?${queryString_var}`;

      console.log("URL", url)

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.graphData = res.data;
      this.graphData.forEach((data: any) => {
        const cw = data.correctWrongData?.datasets?.data;
        if (Array.isArray(cw)) {
          const fixed = cw.map((v: unknown) =>
            v == null || Number.isNaN(Number(v)) ? 0 : Number(v)
          );
          data.correctWrongData = {
            ...data.correctWrongData,
            datasets: {
              ...data.correctWrongData.datasets,
              data: fixed,
            },
          };
        }
        if (data.type == 'bar' && data.questionType !== 'DRAG_DROP') {
          data.graphData = this.getBarGraph(data.data, data.questionType);
        } else if (data.type == 'smile') {
          data.graphData = this.getSmileData(data.data);
        } else if (data.type == 'rate') {
          data.graphData = this.getStartData(data.data);
        } else if (data.questionType == "MULTI_SELECT_SCALE" || data.questionType == "MULTI_POINT_SCALE") {
          data.type = 'table'
          data.data = this.getMatrixData(data.data);
        } else if (data.questionType == "RANK_ORDER") {
          data.type = 'rank_order'
          data.data = this.getRankOrderSummary(data.meta || []);
        } else if (data.questionType == "DRAG_DROP") {
          data.type = 'rank_order'
          data.data = this.getDragDropSummary(data.meta || []);
        } else if (data.questionType == "CALENDAR") {
          data.type = 'calander'
        } else if (data.questionType == "OU_TREE_DROPDOWN") {
          data.type = 'text';
          if (!data.data?.datasets?.[0]?.data && Array.isArray(data.meta)) {
            data.data = {
              labels: [data.questionText],
              datasets: [{ data: data.meta.map((m: any) => [m?.selectedOu?.label ?? m?.value ?? '']) }]
            };
          } else if (data.data?.datasets?.[0]?.data) {
            data.data.datasets[0].data = (data.data.datasets[0].data || []).map((row: any) =>
              Array.isArray(row) ? row : [row]
            );
          }
        } else if (["DATE_TIME", "PRESENTATION_TEXT", "SECTION_HEADING", "SECTION_SUB_HEADING", "DYNAMIC_MESSAGE"].includes(data.questionType)) {
          data.type = 'info'
        }
      });

      this.getGradesData.emit([this.totalGradesData, this.totalQuestionsDataGraph, this.alldata?.domainAnswers || [], this.alldata, this.topStats, this.graphData])

    } catch (e) {
      console.log("Error", e)
    }
  }

  updateMultiTakersPage(event?: any) {
    const source = this.multiTakersFilteredData && this.multiTakersFilteredData.length >= 0
      ? this.multiTakersFilteredData
      : (this.alldata?.listOfMuliTakers || []);

    const rows = event?.rows ?? this.multiTakersRows ?? 10;
    const page = event?.page ?? (event?.first != null ? Math.floor(event.first / rows) : this.multiTakersPage) ?? 0;
    const first = event?.first ?? page * rows;

    this.multiTakersPage = page;
    this.multiTakersRows = rows;

    this.multiTakersPageData = source.slice(first, first + rows);
  }

  onMultiTakersSearchChange(term: string) {
    this.multiTakersSearchTerm = term || '';
    const all = this.alldata?.listOfMuliTakers || [];
    const needle = this.multiTakersSearchTerm.toLowerCase();

    this.multiTakersFilteredData = !needle
      ? all
      : all.filter((item: any) => {
        const email = (item._id || '').toString().toLowerCase();
        const name = (item.name || '').toLowerCase();
        const assessments = Array.isArray(item.assessments)
          ? item.assessments.join(' ').toLowerCase()
          : '';
        return email.includes(needle) || name.includes(needle) || assessments.includes(needle);
      });

    // Reset to first page after filtering
    this.updateMultiTakersPage({ page: 0, rows: this.multiTakersRows, first: 0 });
  }


  async getResults() {
    // Convert percentage input (1-100) to decimal (0-1)
    this.worstPerformingQuestionPercentage = this.worstPerformingQuestionPercentageInput / 100;

    const queryString = Object.keys(this.params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.params[key])}`)
      .join('&');

    let queryString_var = queryString.replace(/%3F/g, '&').replace(/%3D/g, '=').replace(/%253F/g, '&').replace(/%253D/g, '=');

    console.log("queryString_var", queryString_var)
    console.log("this.params", this.params)

    this.selectedFilterOptions.value


    try {
      let res: any;
      await this.dataService.getData(
        `${this.from}-result/getBulkResults?` + queryString_var + '&filtering=' + this.selectedFilterOptions + '&worstPerformingQuestionPercentage=' + this.worstPerformingQuestionPercentage
      ).then((response: any) => {
        res = response;
        this.hideContent = false;
      });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      this.alldata = res.data[0];

      // Seed multi-takers filtered data and first page
      this.multiTakersFilteredData = this.alldata?.listOfMuliTakers || [];
      this.updateMultiTakersPage({ page: 0, rows: this.multiTakersRows, first: 0 });

      this.topStats = []

      this.subTopStats = []

      this.totalGrades = this.alldata["Total Grades"]

      this.totalGradesData = await this.generateData(this.totalGrades);
      console.log('alldata', this.alldata);


      this.criterias = this.alldata["Criteria"]

      this.totalUserResults = this.alldata["Total number of who attempted"].value ? this.alldata["Total number of who attempted"].value : 0;

      if (Array.isArray(this.criterias)) {
        this.criterias.sort((a: any, b: any) => b.data.length - a.data.length);

        this.criterias.forEach((ele: any) => {
          if (Array.isArray(ele.data)) {
            ele.data.sort((a: any, b: any) => b.from - a.from);
          }
        });
      }

      this.totalQuestionsData = this.alldata["CorrectQuestions"];

      this.worstPerformingQuestions = this.alldata["Worst Performing Questions"]

      if (
        Array.isArray(this.worstPerformingQuestions) &&
        this.worstPerformingQuestions.length > 0 &&
        this.worstPerformingQuestions[0] &&
        this.worstPerformingQuestions[0].correct &&
        this.worstPerformingQuestions[0].count
      ) {
        this.mistakersPercentage = round((this.worstPerformingQuestions[0].correct / this.worstPerformingQuestions[0].count) * 100)
      }



      this.totalQuestionsDataGraph = await this.generateQuestionsData(this.totalQuestionsData);

      const skippinglist = ["Total Grades", "Criteria", "CorrectQuestions", "Worst Performing Questions"]

      for (const key in this.alldata) {
        if (Object.prototype.hasOwnProperty.call(this.alldata, key)) {
          if (!skippinglist.includes(key)) {
            const value = this.alldata[key];
            value.icon = this.getIcon(key);
            value.type = this.getType(key);
            console.log(value.icon)
            console.log("key", key)
            if (this.isSubCards.includes(key)) {
              this.subTopStats.push({ key, value });
            }
            else {
              if (!this.hiddenItems.includes(key)) {
                this.topStats.push({ key, value });
              }

            }
          }
        }
      }

      if (this.from === 'assessment') {
        this.topStats = this.reorderTopStatsForExamSummary(this.topStats);
      }

      this.getGradesData.emit([this.totalGradesData, this.totalQuestionsDataGraph, this.alldata.domainAnswers, this.alldata, this.topStats, this.graphData])

      this.cdr.markForCheck();

      if (this.alldata?.['Total Marks'] && this.alldata['Total Marks'].value) {
        this.totalMarks = this.formatScore(this.alldata['Total Marks'].value);
      }
      console.log("all data", this.topStats);

    } catch (error) {
      console.log(error);
    }


  }

  /** Hide top stat cards when value is empty, numeric zero, or string "0". */
  isStatVisible(item: { key: string; value: { value?: unknown } }): boolean {
    const v = item?.value?.value;
    if (v === null || v === undefined) return false;
    if (typeof v === 'number' && (v === 0 || Number.isNaN(v))) return false;
    if (typeof v === 'string') {
      const t = v.trim();
      if (t === '' || t === '0') return false;
    }
    if (typeof v === 'boolean' && !v) return false;
    return true;
  }

  private reorderTopStatsForExamSummary(stats: { key: string; value: any }[]): { key: string; value: any }[] {
    const order = [...this.examSummaryStatOrder];
    const prioritized = order
      .map((k) => stats.find((s) => s.key === k))
      .filter((s): s is { key: string; value: any } => !!s);
    const rest = stats.filter((s) => !order.includes(s.key));
    return [...prioritized, ...rest];
  }

  getSubCards(key: any) {
    if (key == 'Total Attendees') {
      const filteredsubTopStats = this.subTopStats.filter((item: any) => item.key == 'External Attendees' || item.key == 'Internal Attendees');
      return filteredsubTopStats;
    }
    else if (key == 'Total number of who attempted') {
      const filteredsubTopStats = this.subTopStats.filter((item: any) => item.key == 'External Attendees  who attempted' || item.key == 'Internal Attendees who attempted');
      return filteredsubTopStats;
    }
    else {
      return [];
    }

  }

  getBarGraph(graphdata: any, name: string): any {
    const colorPalette = ['#facb7d', '#f7517f', '#47276d', '#290d4e', '#703d94', '#16ceb9', '#6648ff', '#3f4357'];
    const multiColorPalette: any = {
      "Correct": '#facb7d',
      "Incorrect": '#f7517f'
    };

    if (graphdata && Array.isArray(graphdata.datasets)) {
      const processedDatasets = graphdata.datasets.map((dataset: any, datasetIndex: number) => {
        if (!dataset || !Array.isArray(dataset.data)) {
          return { backgroundColor: [], label: dataset?.label || '', data: [] };
        }

        const labels = Array.isArray(graphdata.labels) ? graphdata.labels : (Array.isArray(dataset.labels) ? dataset.labels : []);

        const sortedData = dataset.data
          .map((value: number, index: number) => ({ value, label: labels[index] || '' }))
          .sort((a: { value: number; }, b: { value: number; }) => b.value - a.value);

        const sortedValues = sortedData.map((item: { value: any; }) => item.value);
        const sortedLabels = sortedData.map((item: { label: any; }) => item.label);

        const totalAnswers = sortedValues.reduce((sum: number, val: number) => sum + val, 0);

        let dataPercentage = sortedValues.map((value: number) => {
          if (totalAnswers > 0) {
            return ((value / totalAnswers) * 100).toFixed(2);
          }
          return '0.00';
        });
        // let concatenatedLabels = sortedValues.map((data: string, index: number) => `(${data}) ${sortedLabels[index]}`);
        let backgroundColors = sortedValues.map(() => multiColorPalette[dataset.label] || '#cccccc');

        return {
          backgroundColor: backgroundColors,
          label: dataset.label,
          data: dataPercentage
        };
      });

      return {
        labels: this.labelmaker(Array.isArray(graphdata.labels) ? graphdata.labels : []),
        datasets: processedDatasets
      };
    } else if (graphdata && graphdata.datasets && typeof graphdata.datasets === 'object') {
      if (!Array.isArray(graphdata.datasets.data)) {
        return { labels: [], datasets: [] };
      }

      const labels = Array.isArray(graphdata.labels) ? graphdata.labels : (Array.isArray(graphdata.label) ? graphdata.label : []);

      const sortedData = graphdata.datasets.data
        .map((value: number, index: number) => ({ value, label: labels[index] || '' }))
        .sort((a: { value: number; }, b: { value: number; }) => b.value - a.value);

      const sortedValues = sortedData.map((item: { value: any; }) => item.value);
      const sortedLabels = sortedData.map((item: { label: any; }) => item.label);

      const totalAnswers = sortedValues.reduce((sum: number, val: number) => sum + val, 0);

      let dataPercentage = sortedValues.map((value: number) => {
        if (totalAnswers > 0) {
          return ((value / totalAnswers) * 100).toFixed(2);
        }
        return '0.00';
      });
      let concatenatedLabels = sortedValues.map((data: string, index: number) => `(${data}) ${sortedLabels[index]}`);
      let backgroundColors = sortedValues.map((_: any, index: number) => colorPalette[index % colorPalette.length]);

      return {
        labels: this.labelmaker(concatenatedLabels),
        datasets: [
          {
            backgroundColor: backgroundColors,
            label: graphdata.datasets.label,
            data: dataPercentage
          }
        ]
      };
    }
  }


  getSmileData(data: any) {
    const labels = data.label || [];
    const images = data.label_images || [];
    const datasets = Array.isArray(data.datasets) ? data.datasets[0]?.data : data.datasets?.data;
    if (!datasets) return [];
    
    const maxLength = Math.max(labels.length, images.length, datasets.length);
    if (maxLength === 0) return [];

    return Array.from({ length: maxLength }, (_, index) => {
      const label = labels[index] || '';
      const image = images[index] || '';
      const rawCount = datasets[index] || 0;
      const percentage = this.totalUserResults > 0 ? ((rawCount / this.totalUserResults) * 100).toFixed(2) : '0.00';
      return { label, image, count: percentage, rawCount };
    });
  }

  getStartData(data: any) {
    const labels = data.label || [];
    const datasets = Array.isArray(data.datasets) ? data.datasets[0]?.data : data.datasets?.data;
    if (!datasets) return [];
    
    const maxLength = Math.max(labels.length, datasets.length);
    if (maxLength === 0) return [];

    return Array.from({ length: maxLength }, (_, index) => {
      const label = labels[index] || '';
      const value = datasets[index] || 0;
      return { label, value, rawCount: value };
    });
  }

  cleanArray(arr: any[]): any[] {
    let first = arr
      .filter(item => item !== null && item !== undefined && item !== "")
      .map(item => Array.isArray(item) ? this.cleanArray(item) : item);
    return first.filter(e => {
      if (Array.isArray(e)) {
        return e.length > 0;
      }
      return e != null && e != undefined && e != "";
    })
  }

  async generateQuestionsData(totalQuestionsData: any) {


    this.options2 = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            font: {
              size: 14,
              family: 'SSTArabic'
            },
            color: '#787878'
          },
          position: "bottom"
        },
        tooltip: {
          enabled: false,
          external: this.external2
        }
      },

    };

    console.log("Option 2", this.options2);

    console.log("totalQuestionsData", totalQuestionsData)

    if (!totalQuestionsData || totalQuestionsData.value == null || totalQuestionsData.total == null || typeof totalQuestionsData.value !== 'number' || typeof totalQuestionsData.total !== 'number' || totalQuestionsData.total === 0) {
      return {
        labels: [this.translate("Average correct answers"), this.translate("Average incorrect answers")],
        datasets: [
          {
            data: [0, 0],
            backgroundColor: this.colors
          }
        ]
      };
    }

    const correct = round((totalQuestionsData.value / totalQuestionsData.total) * 100)
    const incorrect = round(((totalQuestionsData.total - totalQuestionsData.value) / totalQuestionsData.total) * 100)

    return {
      labels: [this.translate("Average correct answers"), this.translate("Average incorrect answers")],
      datasets: [
        {
          data: [correct, incorrect],
          backgroundColor: this.colors
        }
      ]
    };
  }

  labelmaker(inputArray: string[]): string[][] {
    const result: string[][] = [];
    inputArray.forEach(item => {
      if (item.length <= 30) {
        result.push([item]);
      } else {
        result.push(["..." + item.substring(0, 30)]);
      }
    });
    return result;
  }


  getIcon(key: string): any {
    switch (key) {
      case "Number of types of Assessments":
        return "icon-svg icon-svg-11";
      case "Number of Assessments":
        return "icon-svg icon-svg-130";
      case "The Number of Questions":
        return "icon-svg icon-svg-7"
      case "Minimum number of questions in an assessment":
        return "icon-svg icon-svg-12"
      case "Total Attendees":
        return "icon-svg icon-svg-3"
      case "Internal Attendees":
        return "icon-svg icon-svg-85"
      case "External Attendees":
        return "icon-svg icon-svg-105"
      case "Total number of who attempted":
        return "icon-svg icon-svg-42"
      case "KGate registered users who attempted":
        return "icon-svg icon-svg-85"
      case "Total number of who missed":
        return "icon-svg icon-svg-57"
      case "Average Time Taken":
        return "icon-svg icon-svg-56"
      case "Total Time":
        return "icon-svg icon-svg-24"
      case "Lowest Time":
        return "icon-svg icon-svg-59"
      case "Highest Time":
        return "icon-svg icon-svg-59"
      case 'Overall average for the assessment in grades':
        return "icon-svg icon-svg-1"
      case "Overall average for the assessment in marks":
        return "icon-svg icon-svg-2"
      default:
        return "icon-svg icon-svg-128";
    }
  }

  getType(key: string): any {
    switch (key) {
      case "Number of types of Assessments":
        return "Forms";
      case "Number of Assessments":
        return "Assessments";
      case "The Number of Questions":
        return "Assessment Question"
      case "Minimum number of questions in an assessment":
        return "Assessment Question"
      case "Total Attendees":
        return "Assessment Attendees"
      case "Internal Attendees":
        return "Assessment Attendees"
      case "External Attendees":
        return "Assessment Attendees"
      case "Total number of who attempted":
        return "Assessment Attendees"
      case "KGate registered users who attempted":
        return "Assessment Attendees"
      case "Total number of who missed":
        return "Assessment Attendees"
      default:
        return "Assessment Attendees";
    }
  }

  getRankOrderSummary(meta: any[]): any {
    if (!meta || meta.length === 0) return { labels: [], distribution: {}, maxRank: 0, ranks: [] };
    const labelScores: { [key: string]: number } = {};
    const labelCounts: { [key: string]: number } = {};
    const distribution: { [label: string]: { [rank: number]: number } } = {};
    let maxRank = 0;

    meta.forEach(response => {
      if (response.fields && Array.isArray(response.fields)) {
        response.fields.forEach((f: any) => {
          const rank = parseInt(f.value);
          if (!isNaN(rank) && rank > 0) {
            labelScores[f.label] = (labelScores[f.label] || 0) + rank;
            labelCounts[f.label] = (labelCounts[f.label] || 0) + 1;

            if (!distribution[f.label]) distribution[f.label] = {};
            distribution[f.label][rank] = (distribution[f.label][rank] || 0) + 1;
            if (rank > maxRank) maxRank = rank;
          }
        });
      }
    });

    const averageRanks = Object.keys(labelScores).map(label => ({
      label,
      avg: labelScores[label] / labelCounts[label]
    }));

    averageRanks.sort((a, b) => a.avg - b.avg);

    return {
      labels: averageRanks.map(item => item.label),
      averages: averageRanks.map(item => item.avg),
      distribution: distribution,
      maxRank: maxRank,
      ranks: Array.from({ length: maxRank }, (_, i) => i + 1)
    };
  }

  getDragDropSummary(meta: any[]): any {
    if (!meta || meta.length === 0) return { labels: [], distribution: {}, maxRank: 0, ranks: [] };
    const labelScores: { [key: string]: number } = {};
    const labelCounts: { [key: string]: number } = {};
    const distribution: { [label: string]: { [rank: number]: number } } = {};
    let maxRank = 0;

    meta.forEach(response => {
      const fields = response.orderedFields || response.fields;
      if (fields && Array.isArray(fields)) {
        fields.forEach((f: any, index: number) => {
          const rankValue = parseInt(f.value);
          const rank = !isNaN(rankValue) && rankValue > 0 ? rankValue : (index + 1);

          labelScores[f.label] = (labelScores[f.label] || 0) + rank;
          labelCounts[f.label] = (labelCounts[f.label] || 0) + 1;

          if (!distribution[f.label]) distribution[f.label] = {};
          distribution[f.label][rank] = (distribution[f.label][rank] || 0) + 1;
          if (rank > maxRank) maxRank = rank;
        });
      }
    });

    const averageRanks = Object.keys(labelScores).map(label => ({
      label,
      avg: labelScores[label] / labelCounts[label]
    }));

    averageRanks.sort((a, b) => a.avg - b.avg);

    return {
      labels: averageRanks.map(item => item.label),
      averages: averageRanks.map(item => item.avg),
      distribution: distribution,
      maxRank: maxRank,
      ranks: Array.from({ length: maxRank }, (_, i) => i + 1)
    };
  }

  getMatrixData(graphdata: any): any {
    if (graphdata && Array.isArray(graphdata.datasets)) {
      const processedDatasets = graphdata.datasets.map((dataset: any) => {
        let dataPercentage = dataset.data.map((value: number) => {
          if (this.totalUserResults > 0) {
            return ((value / this.totalUserResults) * 100).toFixed(2);
          }
          return '0.00';
        });
        let backgroundColors = dataset.data.map(() => '#1b75bb');

        return {
          backgroundColor: backgroundColors,
          label: dataset.label,
          data: dataPercentage,
          counts: dataset.data
        };
      });

      return {
        labels: this.labelmaker(graphdata.labels),
        datasets: processedDatasets
      };
    }
    return graphdata;
  }

  calculatePercentage(question: { count: number; correct: number }): number | null {
    if (!question.count) return null;
    const result = ((question.count - question.correct) / question.count) * 100;
    return Math.round(result); // Round to 1 decimal place
  }

  cleanQuestionText(text: string): string {
    if (text) {
      return text.replace(/^س\d+\s*[:：]/, '').replace(/[:：]$/, '').trim();
    }
    else {
      return text;
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  external1 = function (context: any) {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';

      let style = 'background: white';
      style += '; color: black';
      tooltipEl.innerHTML = '<table dir="rtl" style="' + style + '"></table>';

      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    const tooltipModel = context.tooltip;
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }

    function getBody(bodyItem: { lines: any }) {
      return bodyItem.lines;
    }

    // Set Text
    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map(getBody);

      let innerHtml = '<thead>';

      titleLines.forEach(function (title: string) {
        innerHtml += '<tr><th><span style="padding: 10px">' + title + '</span></th></tr>';
      });
      innerHtml += '</thead><tbody>';

      bodyLines.forEach(function (body: string, i: string | number) {
        const colors = tooltipModel.labelColors[i];
        let style = 'background:' + colors.backgroundColor;
        style += '; border-color:' + colors.borderColor;
        style += '; border-width: 2px';
        style += '; color: white';
        style += '; text-align: center; width: 100%';
        const span = '<span>' + body + ' مختبر </span>';
        innerHtml += '<tr style="' + style + '" ><td style="padding: 5px 10px">' + span + '</td></tr>';
      });
      innerHtml += '</tbody>';

      let tableRoot = tooltipEl.querySelector('table');
      if (tableRoot) {
        tableRoot.innerHTML = innerHtml;
      }
    }

    const position = context.chart.canvas.getBoundingClientRect();

    // Display, position, and set styles for font
    tooltipEl.style.opacity = '1';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left =
      position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top =
      position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.padding =
      tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
    tooltipEl.style.pointerEvents = 'none';
  }

  external2 = function (context: any) {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';

      let style = 'background: white';
      style += '; color: black';

      tooltipEl.innerHTML = '<table dir="rtl" style="' + style + '"></table>';

      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    const tooltipModel = context.tooltip;
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }

    function getBody(bodyItem: { lines: any }) {
      return bodyItem.lines;
    }

    // Set Text
    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map(getBody);

      let innerHtml = '<thead>';

      titleLines.forEach(function (title: string) {
        innerHtml += '<tr><th><span style="padding: 10px">' + title + '</span></th></tr>';
      });
      innerHtml += '</thead><tbody>';

      bodyLines.forEach(function (body: string, i: string | number) {
        const colors = tooltipModel.labelColors[i];
        let style = 'background:' + colors.backgroundColor;
        style += '; border-color:' + colors.borderColor;
        style += '; border-width: 2px';
        style += '; color: white';
        style += '; text-align: center; width: 100%';
        const span = '<span>' + body + '% </span>';
        innerHtml += '<tr style="' + style + '" ><td>' + span + '</td></tr>';
      });
      innerHtml += '</tbody>';

      let tableRoot = tooltipEl.querySelector('table');
      if (tableRoot) {
        tableRoot.innerHTML = innerHtml;
      }
    }

    const position = context.chart.canvas.getBoundingClientRect();

    // Display, position, and set styles for font
    tooltipEl.style.opacity = '1';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left =
      position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top =
      position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.padding =
      tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
    tooltipEl.style.pointerEvents = 'none';
  }

  formatScore(value: number) {
    return Math.round(value);
  }

  public async exportCorrectWrongExcel() {
    this.downloadCWExcel = true
    let cleanData: any = await this.fetchBulkExcelData()
    let updatedDataArray;
    updatedDataArray = cleanData.map((item: any) => {
      const { question, correct, incorrect, topic, type, assessments } = item;
      let updatedItem: any = {
        'السؤال': question,
        'المواضيع': topic,
        'تصنيف': type,
        'الاختبارات': assessments,
        'الإجابات الصحيحة': correct,
        'الإجابات الخاطئة': incorrect
      };
      return updatedItem;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray);
    this.downloadCWExcel = false
  }

  async fetchBulkExcelData() {
    try {
      let url = `${this.from}-result/bulkExcel`;
      let queryString = 'ids=' + this.assessmentIds.join(',');

      let queryString_var = queryString.replace(/%3F/g, '&').replace(/%3D/g, '=').replace(/%253F/g, '&').replace(/%253D/g, '=');

      console.log("queryString_var", queryString_var)
      console.log("this.params", this.params)

      if (queryString_var) {
        url += `?${queryString_var}`;
      }
      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      console.log("RES", res.data);
      return res.data;
    } catch (e) {
      console.log("error", e);
    }
  }


  public async exportExcel() {
    this.downloadExcel = true
    let cleanData: any = await this.fetchExcelData()
    let updatedDataArray = cleanData.map((item: any) => {
      const { question, email, attendance, externalName, externalFields, score, total, percentage, percentageCriteria } = item;
      let updatedItem: any = {
        'الاسم': externalName ? externalName : '-',
        'البريد الإلكتروني': email,
        ...externalFields,
        'الحضور': attendance ? this.translate(attendance) : '-',
        'الدرجات': this.formatScore(score),
        'مجموع درجات': total,
        'النسبة': this.formatScore(percentage),
        'التقدير': percentageCriteria
      };
      updatedItem = { ...updatedItem, ...question };
      return updatedItem;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray);
    this.downloadExcel = false
  }

  public async exportToPPTForMultitakers() {
    this.downloadExcel = true
    let cleanData: any = this.alldata.listOfMuliTakers;
    let updatedDataArray = cleanData.map((item: any) => {
      const { _id, name, sum, assessments } = item;
      let updatedItem: any = {
        'الاسم': name ? name : '-',
        'البريد الإلكتروني': _id,
        "عدد المرات": sum ? sum : '-',
        'الاختبارات': assessments ? assessments.join(', ') : '-'
      };
      return updatedItem;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray);
    this.downloadExcel = false
  }

  public async exportPdf() {
    this.downloadPdf = true;
    let cleanData: any = await this.fetchPdfData();

    let pageOrientation: any = 'portrait';
    let updatedDataArray = cleanData.map((item: any) => {
      let updatedItem: any;
      pageOrientation = 'landscape'
      const { name, email, phone, gender, score, totalMarks, criteria, timeTaken, percentage, questions } = item;
      updatedItem = {
        'التقدير': this.reverseWordsForRTL(criteria || '-'),
        'المستغرق  الوقت': this.reverseWordsForRTL(timeTaken || '-'),
        'النسبة': this.reverseWordsForRTL(percentage + " %" || '-'),
        [`${this.totalMarks} من  الدرجات`]: this.reverseWordsForRTL(score || '-'),
        'الجنس': this.reverseWordsForRTL(gender || '-'),
        'الهاتف  المحمول  رقم': this.reverseWordsForRTL(phone || '-'),
        'الإلكتروني  البريد': this.reverseWordsForRTL(email || '-'),
        'الاسم': this.reverseWordsForRTL(this.getName(name) || '-'),
      };
      return updatedItem;
    });

    console.log("updatedDataArray", updatedDataArray)

    this.exportService.exportToPdf(updatedDataArray, '', pageOrientation);
    this.downloadPdf = false
  }

  async fetchPdfData() {
    try {
      let url = `${this.from}-result/pdf`;
      let queryString = 'ids=' + this.assessmentIds.join(',');
      if (queryString) {
        url += `?${queryString}`;
      }
      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      return res.data;
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchExcelData() {
    try {

      let url = `${this.from}-result/bulkUserExcel`;
      let queryString = 'ids=' + this.assessmentIds.join(',');
      if (queryString) {
        url += `?${queryString}`;
      }

      console.log("URL", url);

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      console.log("RES", res.data);
      return res.data
    } catch (e) {
      console.log("error", e)
    }
  }

  reverseWordsForRTL(text: string): string {
    if (this.isArabicText(text)) {
      return text.split(' ').reverse().join('  ');
    }
    return text;
  }

  getName(name: any): string {
    if (typeof name === 'object' && name !== null) {
      return Object.values(name).join(' ');
    } else {
      return name;
    }
  }

  isArabicText(text: string): boolean {
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
    return arabicPattern.test(text);
  }



  async exportToPPT() {
    try {
      this.downloadPowerPoint = true;
      let pres = new pptxgen();
      console.log("this.alldata", this.alldata);
      let allData = this.alldata;

      const fontFace = "DIN Next LT Arabic";

      // Convert data array into a comma-separated string
      const assessmentsData: string = this.alldata["Number of Assessments"].data
        .map((item: [string]) => item[0]) // Extract each string from the nested arrays
        .join(", "); // Join them with a comma and a space

      pres.defineSlideMaster({
        title: "MASTER_SLIDE",
        background: { color: "FFFFFF" },
        objects: [
          { text: assessmentsData, options: { x: '4%', y: '30%', w: 5.5, h: 0.75, fontSize: 30, bold: true, fontFace: fontFace } },
          { image: { x: '70%', y: '85%', w: '25%', h: '10%', path: "assets/sbc_logo.png" } },
        ] as any, // Cast to 'any' to avoid TypeScript error
      });

      pres.addSlide({ masterName: "MASTER_SLIDE" });

      // Define the type for alldata and stats
      type StatEntry = { value?: string | number };
      type AllData = Record<string, StatEntry>;

      let stats: AllData = Object.fromEntries(
        Object.entries(this.alldata as AllData).filter(
          ([key]) => !this.hiddenItems.includes(key) && !this.hideCards.includes(key)
        )
      );

      console.log('1');

      if (Object.keys(stats).length > 0) {
        let slide = pres.addSlide();
        slide.addText(":بيانات عامة ", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });

        let tableData: any[] = [
          [{ text: this.translate('Title'), options: { bold: true } }, { text: this.translate('statistics'), options: { bold: true } }].reverse()
        ];

        for (let [key, value] of Object.entries(stats)) {
          tableData.push([this.translate(key), value?.value ?? ''].reverse());
        }

        console.log('TABLE', tableData);
        slide.addTable(tableData, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace });
      }

      //Pi Charts
      let finalGradeData = this.alldata['domainAnswers']
      console.log('2')
      for (let data of finalGradeData) {
        let slide = pres.addSlide();
        let chartData: any[] = [];

        for (let dataset of data.datasets) {
          chartData.push({ labels: data.labels, values: dataset.data })
        }

        console.log(data._id);

        slide.addChart(pres.ChartType.pie, chartData, { title: data._id, x: 1, y: 1, w: 8, h: 4, chartColors: this.chartColors, showLabel: false, dataLabelFontFace: fontFace, legendFontFace: fontFace, fontFace, titleFontFace: fontFace, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
      }

      console.log('3')
      console.log(" this.totalGradesData", this.alldata["Total Grades"])
      //More Pi charts with heading
      let totalGrades = [this.totalGradesData];
      if (!!totalGrades && totalGrades.length > 0) { // Add a check for the array and its length
        for (let data of totalGrades) {
          let slide = pres.addSlide();
          let chartData: any[] = [];

          // Ensure data and its properties exist before proceeding
          if (data && data.datasets) {
            for (let dataset of data.datasets) {
              chartData.push({ labels: data.labels, values: dataset.data });
            }
          }

          let title: string = '';
          if (data && data._id) {
            // Handle cases where _id might be a string or an object with a label
            title = typeof data._id === 'string' ? data._id : (data._id.label ?? '');
          }

          if (title) { // Only add the text if the title is not empty
            slide.addText([{ text: title, options: { bold: true } }], { x: '40%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, fontFace });
          }

          // Add the chart only if chartData is populated
          if (chartData.length > 0) {
            slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 1, w: 8, h: 4, chartColors: this.chartColors, titleFontFace: fontFace, legendFontFace: fontFace, fontFace, showLabel: false, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
          }
        }
      }

      //Card data in table
      let keys = [
        'Overall average for the assessment in percentage',
        'Overall average for the assessment in marks',
        'Overall average for the assessment in grades'
      ]

      console.log('4')
      if (!!allData) {
        let percentage = allData['Overall average for the assessment in percentage']?.value
        let marks = allData['Overall average for the assessment in marks']?.value
        let grades = allData['Overall average for the assessment in grades']?.value

        const tableData: any[] = []
        tableData.push([{ text: this.translate(keys[0]), options: { bold: true } }, { text: this.translate(keys[1]), options: { bold: true } }, { text: this.translate(keys[2]), options: { bold: true } }]);
        tableData.push([percentage, marks, grades])

        let slide = pres.addSlide();
        slide.addText(":المعدل العام", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace })
        slide.addTable(tableData, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace })
      }

      console.log('5')
      //Bar and tables
      if (this.graphData) {

        for (let data of this.graphData) {
          // SECTION HEADING (info type)
          if (data.type === 'info') {
            let slide = pres.addSlide();
            slide.addText(data.questionText, { x: 0.5, y: '40%', w: 9, fontSize: 24, bold: true, fontFace, align: 'center', color: '47276d' });
            continue;
          }
          if (data.type == 'bar') {
            if (!data.graphData || !data.graphData.datasets || !data.graphData.labels) continue;
            let slide = pres.addSlide();
            let chartData: any[] = [];
            for (let dataset of data.graphData.datasets) {
              chartData.push({ name: dataset.label, labels: data.graphData.labels.flat(Infinity), values: dataset.data })
            }
            slide.addChart(pres.ChartType.bar, chartData, { title: data.questionText, x: 1, y: 1, w: 8, h: 4, showTitle: true, titleFontFace: fontFace, legendFontFace: fontFace, fontFace, legendFontSize: 10, dataLabelFontSize: 0, chartColors: this.chartColors, showLabel: false, showLegend: true, showPercent: true });
          } else if (data.type == 'text') {
            if (!data.data || !data.data.datasets || !data.data.labels) continue;
            let tableData: any[] = []

            for (const [index, dataset] of data.data.datasets.entries()) {
              if (!dataset.data) continue;
              tableData.push([{ text: data.data.labels[index], options: { bold: true } }])
              tableData.push(...dataset.data)
            }
            if (tableData.length > 0) {
              let slide = pres.addSlide();
              slide.addText(data.questionText, { x: 0.5, y: 0.2, w: 9, h: 0.5, fontSize: 16, bold: true, fontFace, align: 'right' });
              slide.addTable(this.cleanArray(tableData), { border: { pt: 1, color: '808080', type: 'solid' }, y: 0.8, autoPage: true, fontFace });
            }
          }
        }
      }

      console.log('6')

      // --- NEW SECTION: PDF Export Data on Last Pages ---
      console.log('Adding PDF export data to PowerPoint...');
      let cleanDataForPdf = await this.fetchPdfData();

      // Prepare the header row for the table
      const headerRow: any[] = [
        'التقدير',
        'المستغرق  الوقت',
        'النسبة',
        `${this.totalMarks} من  الدرجات`,
        'الجنس',
        'الهاتف  المحمول  رقم',
        'الإلكتروني  البريد',
        'الاسم'
      ].map(header => ({ text: this.reverseWordsForRTL(header), options: { bold: true } })); // Reverse headers for RTL display

      const rowsPerPage = 6; // Define how many rows per page you want

      if (cleanDataForPdf.length > 0) {
        for (let i = 0; i < cleanDataForPdf.length; i += rowsPerPage) {
          const currentPageData = cleanDataForPdf.slice(i, i + rowsPerPage);
          let pdfTableData: any[] = [headerRow]; // Each page gets its own header

          // Process each item for the current page
          currentPageData.forEach((item: any) => {
            const { name, email, phone, gender, score, totalMarks, criteria, timeTaken, percentage, questions } = item;
            const row: any[] = [
              this.reverseWordsForRTL(criteria || '-'),
              this.reverseWordsForRTL(timeTaken || '-'),
              this.reverseWordsForRTL(percentage + " %" || '-'),
              this.reverseWordsForRTL(score || '-'),
              this.reverseWordsForRTL(gender || '-'),
              this.reverseWordsForRTL(phone || '-'),
              this.reverseWordsForRTL(email || '-'),
              this.reverseWordsForRTL(this.getName(name) || '-'),
            ];
            pdfTableData.push(row);
          });

          let slide = pres.addSlide();
          // Add title only on the first page or if explicitly desired on every page
          if (i === 0) {
            slide.addText(":تفاصيل بيانات التقييم", { x: '40%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace, align: 'right' });
          } else {
            // You might want a smaller title or no title on subsequent pages, or repeat the main title.
            // For now, let's keep it consistent if it's a multi-page table.
            slide.addText(":تفاصيل بيانات التقييم", { x: '40%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace, align: 'right' });
            slide.addText("تابع", { x: '40%', y: '2%', w: 1, h: 0.75, fontSize: 12, bold: true, fontFace, align: 'right' });

          }


          slide.addTable(pdfTableData, {
            border: { pt: 1, color: '808080', type: 'solid' },
            y: '18%', // Adjusted Y position to give more vertical space
            w: '95%', // Adjust width to fit content
            autoPage: false, // Set to false as we are manually paginating
            fontFace: fontFace,
            colW: [0.8, 1, 0.8, 1.2, 0.8, 1.2, 1.5, 1.5] // Adjust column widths as needed
          });
        }
      }
      // --- END NEW SECTION ---


      // Write the presentation to a file
      await pres.writeFile({ fileName: "BULK_KGATE_ASSESSMENT.pptx" });
      this.downloadPowerPoint = false;
    } catch (e) {
      console.log('PRINT ERROR', e instanceof TypeError ? e.message : e);
      this.downloadPowerPoint = false;
      //this.skelition = false;
    }
  }

}